import {
  menu,
  getAddressOpts,
  getCountries
} from '@/api.js';
import request from '@/request.js';
import store from '@/store'
import { apiLangKey } from '@/utils/Config.js'

function extractButtonAuth(menu) {
  // 提取按钮权限
  const auth = {}
  menu.forEach((a) => {
    a.children && a.children.forEach(b => {
      const authKey = b.href.split('?')[0]
      auth[authKey] = auth[authKey] || []
      b.children && b.children.forEach(c => {
        auth[authKey].push(c.href)
      })
    })
  })

  store.dispatch('setBtnauth', auth)
}

export const getMenu = function () {
  return request('get', menu)
  .then(res => {
    const isEN = localStorage.getItem(apiLangKey) === 'en'
    if (isEN) {
        res.forEach(i => {
            i.name = i.name_en || i.name
            i.children && i.children.forEach(c => {
              c.name = c.name_en || c.name
              c.children && c.children.forEach(b => {
                  b.name = b.name_en || b.name
              })
            })
        })
    }

    extractButtonAuth(res)
    return res
  })
}

export const getAddressData = function (country_code = 'CN') {
  return request('get', getAddressOpts, { country_code })
}

export const getCountryOptions = function () {
  return request('get', getCountries)
}